import { QueryClient } from '@tanstack/react-query';
import { CURRENT_PRODUCT_MODE, PRODUCT_MODE_MAP } from '@src/utils/constants';
import { atom } from 'jotai';

const { baseUrl } = window.conviva;

export const homePagePath = [
  PRODUCT_MODE_MAP.AI,
  PRODUCT_MODE_MAP.APP,
  PRODUCT_MODE_MAP.ODP,
  PRODUCT_MODE_MAP.EI,
].includes(CURRENT_PRODUCT_MODE)
  ? baseUrl
  : '/app';

export const singleAppPrefix = '/app';

export const queryClient = new QueryClient();

export const coreFetchedAtom = atom(false);
